/** Reviewer rejection severity — shared by web, server, and mobile compliance helpers. */
export const REJECTION_TYPES = [
  'PHOTO_ONLY',
  'REVISIT',
  'REVISIT_WITH_SIGNOFF',
  'ADVISORY_ONLY',
] as const;

export type RejectionType = (typeof REJECTION_TYPES)[number];

/** Cockpit / settings pill and dropdown order (advisory promoted first). */
export const REJECTION_TYPE_DISPLAY_ORDER: readonly RejectionType[] = [
  'ADVISORY_ONLY',
  'PHOTO_ONLY',
  'REVISIT',
  'REVISIT_WITH_SIGNOFF',
];

export function isRejectionType(value: unknown): value is RejectionType {
  return typeof value === 'string' && (REJECTION_TYPES as readonly string[]).includes(value);
}

export function isAdvisoryRejectionType(rejectionType: RejectionType | null | undefined): boolean {
  return rejectionType === 'ADVISORY_ONLY';
}

export function rejectFollowUpActionForType(rejectionType: RejectionType): 'CREATE_REPOST' | 'ADVISORY_FEEDBACK' {
  return rejectionType === 'ADVISORY_ONLY' ? 'ADVISORY_FEEDBACK' : 'CREATE_REPOST';
}

export const REJECTION_TYPE_LABELS: Record<RejectionType, string> = {
  PHOTO_ONLY: 'Photo retake only',
  REVISIT: 'Revisit required',
  REVISIT_WITH_SIGNOFF: 'Revisit + manager sign-off',
  ADVISORY_ONLY: 'Accepted with concerns — no operator work',
};

/** Legacy clients send REJECT for advisory feedback; persist acceptance everywhere. */
export function effectiveReviewDecision(decision: 'APPROVE' | 'REJECT', type?: RejectionType | null): 'APPROVE' | 'REJECT' {
  return isAdvisoryRejectionType(type) ? 'APPROVE' : decision;
}
